// apps/vendor/src/components/VendorAppShell.tsx
//
// Phase 1 Wave 12 Task 92 — Vendor SPA app shell.
//
// Composes VendorSidebar (avatar TOP, flat 5-item nav) + VendorTopBar
// (no wallet, no announcement banner) + main content area. Used by
// Task 95 to wrap authenticated vendor routes.
//
// Welcome banner (orange gradient —) is per-page (Task 98 wires
// it on Dashboard) — NOT global, since deep routes don't get the banner.

import type { ReactNode } from 'react';

import { AppShell } from '@printway/ui';

import VendorSidebar from './VendorSidebar.js';
import VendorTopBar from './VendorTopBar.js';

export interface VendorAppShellProps {
  children: ReactNode;
}

export function VendorAppShell({ children }: VendorAppShellProps): JSX.Element {
  return (
    <AppShell
      sidebar={<VendorSidebar />}
      topBar={<VendorTopBar />}
    >
      {children}
    </AppShell>
  );
}

/**
 * VendorWelcomeBanner — orange gradient hero shown on Dashboard route only.
 * Task 98 (Wave 12.4) renders this inside Vendor HomePage.
 */
export function VendorWelcomeBanner({
  vendorName,
  pendingJobs = 0,
  weekEarnings = '$0',
}: {
  vendorName: string;
  pendingJobs?: number;
  weekEarnings?: string;
}): JSX.Element {
  return (
    <div className="mb-6 rounded-xl bg-gradient-to-r from-pw-primary to-orange-400 p-6 text-white shadow-sm">
      <h1 className="text-2xl font-semibold">Welcome back, {vendorName}</h1>
      <p className="mt-1 text-sm opacity-95">
        You have <strong className="font-semibold">{pendingJobs}</strong>{' '}
        pending {pendingJobs === 1 ? 'job' : 'jobs'} and earned{' '}
        <strong className="font-semibold">{weekEarnings}</strong> this week.
      </p>
    </div>
  );
}

export default VendorAppShell;
